import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0d481b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex flex-col items-center relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-5 left-3 z-10"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "10",
  viewBox: "0 0 16 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 1.5L8.70711 7.79289C8.31658 8.18342 7.68342 8.18342 7.29289 7.79289L1 1.5",
    stroke: "#64676A",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["id", "type", "placeholder", "disabled"]
const _hoisted_6 = {
  key: 0,
  class: "mr-[1px]"
}

import { ref, computed } from 'vue';

interface Props {
    type: string
    modelValue: any
    label: string
    id?: string
    disabled?: boolean
    mandatory?: boolean
    selecBoxIcon?: boolean
    customWidth?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
    type: null,
    modelValue: null,
    label: null,
    id: null,
    disabled: { type: Boolean },
    mandatory: { type: Boolean },
    selecBoxIcon: { type: Boolean },
    customWidth: null
  },
  emits: ["update:model-value", "change", "click", "focus", "onFocus", "input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:model-value', payload: string | number): void,
    (event: 'change', payload: Event): void
    (event: 'click', payload: MouseEvent): void
    (event: 'focus'): void
    (event: 'onFocus'): void
    (event: 'input', payload: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    type: string
    modelValue: any
    label: string
    id?: string
    disabled?: boolean
    mandatory?: boolean
    selecBoxIcon?: boolean
    customWidth?: string
};





const inputElement = ref<HTMLInputElement | null>(null)

const floatingLabel = ref(false)
const inputValue = computed({
    get() {
        if (props.modelValue) {
            floatingLabel.value = true
            // classLabelText.value = 'text-colorNeutral'
        }
        return props.modelValue
    },
    set(value) {
        emit('update:model-value', value)
    },
})


const borderInputData = ref({
    defult: '',
    focus: 'border-primary300',
    disabled: '',
    error: '',
})

const borderInputColor = ref<String>(borderInputData.value.defult)
const classLabelText = ref<String>('')

const focusedInput = () => {
    emit('focus')
    classLabelText.value = ''
    borderInputColor.value = borderInputData.value.focus
    floatingLabel.value = true
}

const focusOut = () => {
    emit('onFocus')
    if (!inputValue.value || inputValue.value == '') {
        floatingLabel.value = false
        borderInputColor.value = borderInputData.value.defult
    } else {
        classLabelText.value = ''
        borderInputColor.value = borderInputData.value.defult
    }
}

const handleInputUpdate = (e: Event) => {
    inputValue.value = (e.target as HTMLInputElement).value
    emit('input', (e.target as HTMLInputElement).value)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.selecBoxIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      ref_key: "inputElement",
      ref: inputElement,
      id: __props.id,
      type: __props.type,
      class: _normalizeClass(["input-global mobile", [borderInputColor.value, __props.customWidth, { 'dir-ltr': __props.type == 'number' }]]),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null)),
      onInput: handleInputUpdate,
      onFocus: focusedInput,
      onFocusout: focusOut,
      spellcheck: "false",
      placeholder: !floatingLabel.value && __props.label ? __props.label : undefined,
      disabled: __props.disabled
    }, null, 42, _hoisted_5), [
      [_vModelDynamic, _unref(inputValue)]
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["label-input", [classLabelText.value, {
            '-translate-y-5 -translate-x-2 opacity-100  z-20 bg-colorNeutral': floatingLabel.value,
            'translate-y-5 translate-x-2 opacity-0 z-0': !floatingLabel.value
        }]])
    }, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      (__props.mandatory)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " * "))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})